// extracted by mini-css-extract-plugin
export default {"loading":"vtsHCanzAbiLRECEkd2M","loading-dual-ring":"HUFWfNTXKLqOI9FoQA6M","darkMode":"Pwvk_hO8ibr1qaHqEXX4"};
    if(module.hot) {
      // 1647894309289
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  